<div class="min-h-screen bg-ambient relative overflow-hidden flex items-center justify-center px-6">

  <div class="absolute top-[-120px] left-[-80px] w-80 h-80 rounded-full bg-[var(--color-primary-light)] blur-3xl opacity-50"></div>
  <div class="absolute bottom-[-140px] right-[-60px] w-96 h-96 rounded-full bg-[var(--color-accent)] blur-3xl opacity-40"></div>

  <div class="relative flex flex-col items-center animate-in-up">

    <div class="relative mb-8">
      <div class="absolute inset-0 rounded-[2rem] bg-[var(--color-primary)]/20 blur-2xl scale-125 animate-pulse-glow"></div>

      <div
        class="relative w-24 h-24 rounded-[2rem] bg-white border border-[var(--color-border)]
               shadow-[var(--shadow-card)] flex items-center justify-center animate-float-slow"
      >
        <div class="absolute inset-2 rounded-[1.5rem] bg-[var(--color-surface)] border border-[var(--color-border)]"></div>
        <img src="./icon.png" alt="Chipo Logo" class="relative w-11 h-11 object-contain" />
      </div>
    </div>

    <div class="text-center space-y-2">
      <h1 class="text-3xl font-bold tracking-tight text-[var(--color-foreground)] font-display">
        Chipo
      </h1>
      <p class="text-sm text-[var(--color-muted-foreground)] leading-relaxed max-w-xs">
        {{ statusMessage }}
      </p>
    </div>

    <div class="flex items-center gap-3 mt-10">
      <span class="w-2.5 h-2.5 rounded-full bg-[var(--color-primary)] animate-bounce" style="animation-delay: 0ms"></span>
      <span class="w-2.5 h-2.5 rounded-full bg-[var(--color-primary-dark)] animate-bounce" style="animation-delay: 150ms"></span>
      <span class="w-2.5 h-2.5 rounded-full bg-[var(--color-secondary)] animate-bounce" style="animation-delay: 300ms"></span>
    </div>

    <div class="mt-8 flex items-center gap-2 text-xs text-[var(--color-muted-foreground)] tracking-wide">
      <div class="w-2 h-2 rounded-full bg-[var(--color-primary)] animate-pulse"></div>
      <span>Secure session check</span>
    </div>

  </div>
</div>
